
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Crown } from "lucide-react";
import { type SubscriptionPlan } from "@/utils/predictionUtils";

interface GameCountSelectorProps {
  gameCount: number;
  onGameCountChange: (count: number) => void;
  userPlan: SubscriptionPlan;
  disabled?: boolean;
}

const GameCountSelector: React.FC<GameCountSelectorProps> = ({ 
  gameCount, 
  onGameCountChange, 
  userPlan,
  disabled = false 
}) => {
  const getMaxGames = (plan: SubscriptionPlan) => {
    switch (plan) {
      case "free": return 5;
      case "basic": return 10;
      case "premium": return 20;
      case "vip": return 50;
      case "quarterly": return 30;
      default: return 5;
    }
  };

  const maxGames = getMaxGames(userPlan);

  return (
    <Card className={disabled ? "opacity-50" : ""}>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          🎲 Quantidade de Jogos
          {userPlan === "free" && <Crown className="w-4 h-4 text-yellow-500" />}
        </CardTitle>
        <CardDescription>
          {userPlan === "free" 
            ? `Máximo ${maxGames} jogos (plano gratuito)` 
            : `Até ${maxGames} jogos por geração`
          }
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Select 
          value={gameCount.toString()} 
          onValueChange={(value) => onGameCountChange(parseInt(value))}
          disabled={disabled}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: maxGames }, (_, i) => i + 1).map((num) => (
              <SelectItem key={num} value={num.toString()}>
                {num} {num === 1 ? "jogo" : "jogos"}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </CardContent>
    </Card>
  );
};

export default GameCountSelector;
